function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.5418 13.5419C13.3421 13.7562 13.1012 13.9282 12.8336 14.0474C12.5659 14.1667 12.277 14.2308 11.9841 14.236C11.6911 14.2411 11.4001 14.1872 11.1284 14.0775C10.8568 13.9678 10.61 13.8044 10.4028 13.5973C10.1956 13.3901 10.0323 13.1433 9.92255 12.8716C9.81282 12.5999 9.75893 12.3089 9.7641 12.016C9.76927 11.723 9.83339 11.4341 9.95264 11.1665C10.0719 10.8989 10.2438 10.658 10.4582 10.4582M16.32 16.3201C15.0768 17.2677 13.563 17.7927 12 17.8182C6.90909 17.8182 4 12.0001 4 12.0001C4.90465 10.3142 6.15937 8.84122 7.68 7.68005L16.32 16.3201ZM10.4727 6.35642C10.9733 6.23924 11.4859 6.18066 12 6.18187C17.0909 6.18187 20 12.0001 20 12.0001C19.5585 12.826 19.032 13.6035 18.4291 14.3201L10.4727 6.35642Z",
  stroke: "#CACED2",
  strokeWidth: 1.4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M4 4L20 20",
  stroke: "#CACED2",
  strokeWidth: 1.4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgEyeOff = function SvgEyeOff(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEyeOff, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/eye-off.f23d2760.svg";
export { ForwardRef as ReactComponent };